import { CoherenceNav, INavLink } from "@coherence-design-system/controls";
import React, { useState }  from "react"; 
import { useNavigate, useParams } from "react-router-dom";
import {GetUserRole} from "../../utils/GetUserRole"   
interface AppNavigationProps {
  onNavCollapsed: (isCollapsed: boolean) => void; 
  isNavCollapsed:boolean;
}

const _isSelected = (location: Location, path: string): boolean => {   
  const currentPath = location.pathname.toLowerCase();
  const targetPath = path.toLowerCase();
  return targetPath.endsWith("/")
    ? currentPath.startsWith(targetPath)
    : currentPath === targetPath;
};

const AppNavigation: React.FunctionComponent<AppNavigationProps> = (props:  AppNavigationProps) => {
  let navigate = useNavigate(); 
  const [userRole, setUserRole] = useState(GetUserRole());
  
    const getLinks = (): INavLink[] => {
    
    var links: INavLink[] = [ ]; 
      links=[
        {
                name: "POR Items",
                key: "porItems_navigation",
                ariaLabel: "POR Items",
                icon: "ProductList",
                onClick: () => {
                    navigate("/PORItems");
                },
                isSelected: _isSelected(window.location, "/PORItems")
            },
            {
                name: "Create POR",
                key: "CreatePOR_navigation",
                ariaLabel: "Create POR",
                icon: "ProductCatalog",
                onClick: () => {
                    navigate("/CreatePOR");
                },
                isSelected: _isSelected(window.location, "/CreatePOR")
            },
            {
                name: "Intake Management",
                key: "IntakeManagement_navigation",
                ariaLabel: "Intake Management",
                icon: "CubeShape",
                onClick: () => {
                    navigate("/IntakeManagement");
                },
                isSelected: _isSelected(window.location, "/IntakeManagement")
            },
            {
                name: "Intent Input Captures",
                key: "IntentInputCaptures_navigation",
                ariaLabel: "Intent Input Captures",
                icon: "EditInput",
                onClick: () => {
                    navigate("/IntentInputCaptures");
                },
                isSelected: _isSelected(window.location, "/IntentInputCaptures")
            },
            {
                name: "Product Configurator",
                key: "ProductConfigurator_navigation",
                ariaLabel: "Product Configurator",
                icon: "ProductVariant",
                onClick: () => {
                    navigate("/ProductConfigurator");
                },
                isSelected: _isSelected(window.location, "/ProductConfigurator")
            }
        ];
        return links;
    };
  
  const getOverviewLinks = (): INavLink[] => {
    var links: INavLink[] = [   
      {
        name: "POR Details",
        key: "PORDetails_navigation",
        ariaLabel: "AddIn",
        icon: "ProductCatalog",
        onClick: () => {          
          const idStartIndex = window.location.href.lastIndexOf('/');
          const id = idStartIndex !== -1 ? window.location.href.substring(idStartIndex + 1) : null; 
            navigate(`/PORDetails/${id}`);
          },
          isSelected: _isSelected(window.location, "/PORDetails/")
          },
          {
          name: "Scope Definition",
          key: "ScopeDefinition_navigation",
          ariaLabel: "AddIn",
          icon: "ScopeDefination",
          onClick: () => {
          const idStartIndex = window.location.href.lastIndexOf('/');
          const id = idStartIndex !== -1 ? window.location.href.substring(idStartIndex + 1) : null; 
          navigate(`/ScopeDefinition/${id}`);
        },
        isSelected: _isSelected(window.location, "/ScopeDefinition/")
      } ,
      {
        name: "Scope Definition Details",
        key: "ScopeDefinitionDetails_navigation",
        ariaLabel: "AddIn",
        icon: "ScopeDefinationDetails",
        onClick: () => {
          const idStartIndex = window.location.href.lastIndexOf('/');
          const id = idStartIndex !== -1 ? window.location.href.substring(idStartIndex + 1) : null; 
            navigate(`/ScopeDefinitionDetails/${id}`);
          },
          isSelected: _isSelected(window.location, "/ScopeDefinitionDetails/")
          }, 
      {
        name: "Data Monitoring",
        key: "DataMonitoring_navigation",
        ariaLabel: "AddIn",
        icon: "Diagnostic",
        onClick: () => {
          const idStartIndex = window.location.href.lastIndexOf('/');
          const id = idStartIndex !== -1 ? window.location.href.substring(idStartIndex + 1) : null;
          navigate(`/DataMonitoring/${id}`);
        },
        isSelected: _isSelected(window.location, "/DataMonitoring/")
      } ,
          {
          name: "Insights",
          key: "Insightsnavigation",
          ariaLabel: "AddIn",
          icon: "GitHub-Action",
          onClick: () => {
          const idStartIndex = window.location.href.lastIndexOf('/');
          const id = idStartIndex !== -1 ? window.location.href.substring(idStartIndex + 1) : null; 
          navigate(`/Insights/${id}`);
        },
        isSelected: _isSelected(window.location, "/Insights/")
      }
    ]; 
        links.push({
            name: "Publish",
            key: "Publishnavigation",
            ariaLabel: "AddIn",
            icon: "Publish",
            onClick: () => {
                const idStartIndex = window.location.href.lastIndexOf('/');
                const id = idStartIndex !== -1 ? window.location.href.substring(idStartIndex + 1) : null; 
                navigate(`/Publish/${id}`);
            },
            isSelected: _isSelected(window.location, "/Publish/")
        });
    return links;
  };

  const getNonManagedLinks = (): INavLink[] => {
    
    var links: INavLink[] = [   
      {
        name: "Non-Managed",
        key: "nonmanaged_navigation",
        ariaLabel: "Non-Managed",
        icon: "GridViewMedium",
        onClick: () => {
          navigate("/NonManaged");
        },
        isSelected: _isSelected(window.location, "/NonManaged") 
      },
      {
         name : "Intent Validations",
         key: "IntentValidations_navigation",
          ariaLabel: "IntentValidations",
          icon: "CustomValidator",
          onClick: () => {
            navigate("/IntentValidations");
          },
          isSelected: _isSelected(window.location, "/IntentValidations")

        },
      {
        name: "OLS Offer ID Generation",
        key: "OLSOfferIDGeneration_navigation",
        ariaLabel: "OLS Offer ID Generation",  
        icon: "CloudFlow",
        onClick: () => {
          navigate("/OLSOffer");
        },
        isSelected: _isSelected(window.location, "/OLSOffer")
      }, 
      {
        name: "Finance Data Audit",
        key: "FinanceDataAudit_navigation",
        ariaLabel: "Finance Data Audit",  
        icon: "TextDocument",
        onClick: () => {
          navigate("/FinanceDataAudit");
        },
        isSelected: _isSelected(window.location, "/FinanceDataAudit")
      },
      {
        name: "Finance Audit History",
        key: "FinanceDataAuditHistory_navigation",
        ariaLabel: "Finance Data Audit History",
        icon: "History",
        onClick: () => {
          navigate("/FinanceDataAuditHistory");
        },
        isSelected: _isSelected(window.location, "/FinanceDataAuditHistory")
      }  
      ];  
    
    // Add Metadata Management link only for OpsAdmin users
    if (userRole.includes("OpsAdmin")) {
      links.push({
        name: "Metadata Management",
        key: "MetadataManagement_navigation",
        ariaLabel: "Metadata Management",
        icon: "MetadataManagement",
        onClick: () => {
          navigate("/MetadataManagement");
        },
        isSelected: _isSelected(window.location, "/MetadataManagement")
      });
    }
    
    return links;
  }; 

  const getExternalWebsiteLinks = (): INavLink[] => {
    
    var links: INavLink[] = [    
      {
        name: "Release Calendar",
        key: "ReleaseCalendar_navigation",
        ariaLabel: "Release Calendar",  
        icon: "Calendar",
        onClick: () => {
          window.open(process.env.REACT_APP_ReleaseCalendarWebsite_URL, "_blank");
        } 
      }
      ]; 

    // Add Release Management link only for users with the Release Management role
    if (userRole.includes("Release Management") || userRole.includes("Admin") || userRole.includes("Accessibility")) {
      links.push({
        name: "Release Management",
        key: "ReleaseManagement_navigation",
        ariaLabel: "Release Management",  
        icon: "ReleaseGateCheck",
        onClick: () => {
          navigate("/ReleaseManagement");
        },
        isSelected: _isSelected(window.location, "/ReleaseManagement")
      });
    }

    return links;
  };

  const groupLinks = (): any => {
    var groupLinks=[];  
      groupLinks.push({
        key: "Left navigation POR menu",
        links: getLinks()
      });   
    if(window.location.pathname.includes("PORDetails") || window.location.pathname.includes("ScopeDefinition") || window.location.pathname.includes("DataMonitoring") || window.location.pathname.includes("Insights") || window.location.pathname.includes("Publish") ) {
      groupLinks.push({ 
        key: "Left navigation Overview menu",
        name:"Overview",
        links: getOverviewLinks()
      });   
    }
    groupLinks.push({        
      key: "Left navigation Non Managed menu", 
      links: getNonManagedLinks()
    });  
    groupLinks.push({        
      key: "Left navigation External menu", 
      links: getExternalWebsiteLinks()
    }); 
    return groupLinks;
  };

  return (
    <div className={props.isNavCollapsed ? 'nav-collapsed' : ''}>    
    <CoherenceNav
    appName={'OPP'}
      groups={ groupLinks()}
      onNavCollapsed={props.onNavCollapsed}
      toggleNavAriaLabel={'OPP navigation'}
      toggleNavTooltip={{ expand: 'Expand Navigation', collapse: 'Collapse Navigation' }} 
    />
    </div>
  );
}; 

export const withRouter = (Component:any) =>{
  const Wrapper = (props:any) =>{
    const history = useNavigate();
    console.log('envt',process.env.REACT_APP_Evn);
    return <Component history={history} {...props}/>
  } 
  return Wrapper;
}
export default withRouter(AppNavigation);
